import type { FetchPolicy } from 'apollo-client';

import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { TitleContentPropertyQuery, HomepageIdQuery } from './TitleContentPropertyQuery.graphql';
import type {
	HomepageIdQuery as HomepageIdQueryType,
	HomepageIdQueryVariables,
} from './__types__/HomepageIdQuery';

const preloadHomepageId = async (spaceKey: string) => {
	const res = await query<HomepageIdQueryType, HomepageIdQueryVariables>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: HomepageIdQuery,
		variables: {
			spaceKey,
		},
	});

	return res?.data?.space?.homepage?.id;
};

const preloadTitleContentProperty = (contentId: string, fetchPolicy: FetchPolicy = 'cache-first') =>
	query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: TitleContentPropertyQuery,
		variables: {
			contentId,
			status: ['current', 'archived', 'draft'],
		},
		fetchPolicy,
	});

export const preloadPageTitleContentProperties = async ({
	contentId,
	contentIdPromise,
	spaceKey,
	fetchPolicy = 'cache-first',
}: {
	contentId: string;
	contentIdPromise?: Promise<string | undefined>;
	spaceKey: string;
	fetchPolicy?: FetchPolicy;
}) => {
	const promises: Promise<any>[] = [];

	if (!contentId) {
		const homepageIdPromise = contentIdPromise || preloadHomepageId(spaceKey);

		promises.push(
			homepageIdPromise.then((homepageId) => {
				return homepageId ? preloadTitleContentProperty(homepageId) : Promise.resolve({});
			}),
		);
	} else {
		promises.push(preloadTitleContentProperty(contentId, fetchPolicy));
	}

	return waitForAllReturnWhenError(promises);
};
